module.exports = __webpack_public_path__ + "fonts/IranYekan.77147e23.ttf";